import { Right } from '@playq/irt';
import { FlowerBlueprintBuzzerBuzzerHandlers } from '@playq/octopus2-analytics';
import type { BlueprintRun, BlueprintRunId } from '@playq/services-flower';
import { CommonSuccess, GenericFailure } from '@playq/services-shared';

import { buzzerBlueprintRunNotifications$ } from '/common/buzzer/buzzerNotifications';
import { Context } from '/api/types';

export class BuzzerBlueprintRunHandlers extends FlowerBlueprintBuzzerBuzzerHandlers<Context, string> {
  statusUpdate(_context: Context, _blueprintId: BlueprintRunId, status: BlueprintRun) {
    buzzerBlueprintRunNotifications$.next(status);

    return Promise.resolve(new Right<GenericFailure, CommonSuccess>(new CommonSuccess()));
  }
}
